<app-title [achievements]="true" [disable]="disable" (onSubmitEvent)='onSubmit()' (editEvent)='edit()'></app-title>

<p class="subtitle1" *ngIf="disable && allAchievements.route.length == 0 && allAchievements.pista.length == 0 && allAchievements.trail.length == 0 && allAchievements.ultra.length == 0">{{'planes.objetivesPopup.emptyAchievements' | translate}}</p>

<!-- ruta -->
<p class="body2" *ngIf="!disable || (disable && rutaHasContent)">{{
    'registration.stepThree.question8.ruta' | translate}}</p>
<div>
    <!-- <p class="subtitle3" *ngIf="!(!isMobile || (isMobile && !disable))"> no muestro este en desktop{{ 'registration.stepThree.question8.ruta' |
        translate}}</p> -->
    <app-achievements [disable]="disable" [edit]="true" [route]="allAchievements.route" [mode]="'ruta'"
        (changeAchievementEvent)="changeAchievement($event)"></app-achievements>
</div>

<!-- pista -->
<p class="body2" *ngIf="!disable || (disable && allAchievements.pista.length > 0)" color="primary">
    {{'registration.stepThree.question8.pista' | translate}}</p>
<div>
    <!-- <p class="subtitle3" *ngIf="!(!isMobile || (isMobile && !disable))">{{ 'registration.stepThree.question8.pista' |
        translate}}</p> -->
    <app-achievements [disable]="disable" [edit]="true" [achievement]="allAchievements.pista" [mode]="'pista'"
        (changeAchievementEvent)="changeAchievement($event)"></app-achievements>
</div>

<!-- trail -->
<p class="body2" *ngIf="!disable || (disable && allAchievements.trail.length > 0)">{{'registration.stepThree.question8.trail' |
    translate}}</p>
<div>
    <!-- <p class="subtitle3" *ngIf="!(!isMobile || (isMobile && !disable))">{{ 'registration.stepThree.question8.trail' |
        translate}}</p> -->
    <app-achievements [disable]="disable" [edit]="true" [achievement]="allAchievements.trail" [mode]="'trail'"
        (changeAchievementEvent)="changeAchievement($event)"></app-achievements>
</div>

<!-- ultra -->
<p class="body2" *ngIf="!disable|| (disable && allAchievements.ultra.length > 0)" color="primary">
    {{'registration.stepThree.question8.ultra' | translate}}</p>
<div>
    <!-- <p class="subtitle3" *ngIf="!(!isMobile || (isMobile && !disable))">{{ 'registration.stepThree.question8.ultra' |
        translate}}</p> -->
    <app-achievements [disable]="disable" [edit]="true" [achievement]="allAchievements.ultra" [mode]="'ultra'"
        (changeAchievementEvent)="changeAchievement($event)"></app-achievements>
</div>